module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mby-wrapper"
  }, [_c('ThreatenedSpeciesMap', {
    attrs: {
      "id": "mby-top"
    }
  }), _vm._v(" "), _c('ElectorateDetails', {
    attrs: {
      "gradesPopupLink": _vm.gradesPopupLink
    }
  }), _vm._v(" "), _c('SpeciesDetails', {
    staticClass: "mby-species-details",
    attrs: {
      "datalayerName": _vm.datalayerName,
      "programName": _vm.programName,
      "messageId": _vm.messageId,
      "cards": _vm.cards,
      "thankYouUrl": _vm.thankYouUrl,
      "privacyPolicyUrl": _vm.privacyPolicyUrl
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mby-disclaimer"
  }, [_vm._v("\n    We acknowledge the First Nations language groups mentioned in the My\n    Backyard tool as the holders of their language and cultural knowledge.\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5e6641e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/threatened-species/ThreatenedSpecies.vue
// module id = 836
// module chunks = 0